<template>
  <div class="button-container">
    <el-button type="primary" @click="goToTranslateTemplate" size="large" :loading="uploading">模板转换</el-button>
    <el-button type="primary" @click="uploadTemplate" size="large" :loading="uploading">上传模板</el-button>
    <el-button type="primary" @click="mergeReport" size="large" :disabled="selectedRows.length < 2">合并报表</el-button>
    <el-button type="primary" @click="getTemplateReportList" size="large">刷新状态</el-button>
  </div>
  <input type="file" ref="uploadInput" @change="handleUploadChange" style="display: none;" accept=".xls,.xlsx" />

  <el-table v-loading="loading" :height="props.height - otherHeight" class="main-container table-container" :data="tableData" highlight-current-row style="width: 100%" @selection-change="handleSelectionChange">
    <el-table-column type="selection" min-width="55" :selectable="row => row.templateCode === 'DR002'" />
    <el-table-column fixed prop="id" label="id" min-width="50" />
    <el-table-column prop="title" label="模板名称" min-width="200">
      <template #default="{ row }">
        <el-tooltip :content="`${row.projectCode} : ${row.title}`" placement="top">
          <span style="display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ row.title }}
          </span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="templateCode" label="模板类型" min-width="120">
      <template #default="{ row }">
        {{ row.templateCode === 'RMerge001' ? '合并报表' : 
           row.templateCode === 'DR002' ? '带表头日报' : 
           row.templateCode }}
      </template>
    </el-table-column>
    <el-table-column prop="status" label="任务状态" min-width="100">
      <template #default="{ row }">
        <el-tag v-if="row.status === 'finished'" type="success">运行完成</el-tag>
        <el-tag v-else-if="row.status === 'running'" type="warning">运行中</el-tag>
        <el-tag v-else-if="row.status === 'wait'" type="info">等待运行</el-tag>
        <el-tag v-else-if="row.status === 'failure'" type="danger">失败</el-tag>
        <el-tag v-else-if="row.status === 'pending'" type="info">待处理</el-tag>
        <el-tag v-else-if="row.status === 'abort'" type="info">放弃执行</el-tag>
        <el-tag v-else-if="row.status === 'release'" type="info">资源已释放</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="reportUrl" label="上次运行报表下载地址" min-width="300">
      <template #default="{ row }">
        <span style="cursor: pointer; color: #409EFF; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" @click="copyUrl(row.reportUrl)" @dblclick="downloadUrl(row.reportUrl)">
          {{ row.reportUrl }}
        </span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" min-width="340">
      <template #default="{ row }">
        <el-button class="report-button" link type="primary" size="small" @click="handleClick(row)" :disabled="row.status === 'running'">
          运行报表
        </el-button>
        <el-button v-if="row.templateCode !== 'RMerge001'" class="report-button" link type="primary" size="small" @click="updateTemplate(row.id)" :loading="uploading">更新模板</el-button>
        <el-button v-if="['RMerge001'].includes(row.templateCode) && row.status !== 'running'" class="report-button" link :type="row.templateCode === 'DR002' ? 'info' : 'primary'" size="small" @click="editTemplate(row)">
          编辑模板
        </el-button>
        <el-button v-if="row.status === 'running'" class="report-button" link type="danger" size="small" @click="abortTemplate(row.id)">终止运行</el-button>
        <el-button v-if="row.templateUrl && row.templateUrl.trim() !== ''" class="report-button" link type="primary" size="small" @click="downloadUrl(row.templateUrl, `${row.title}-${row.templateCode === 'RMerge001' ? '合并报表' : row.templateCode === 'DR002' ? '带表头日报' : row.templateCode}-${new Date().getFullYear()}年${new Date().getMonth() + 1}月${new Date().getDate()}日`)">
          下载模板
        </el-button>
        <el-button class="report-button" type="primary" link size="small" @click="copyText(row.rule,'扩展复制成功')">复制扩展</el-button>
        <el-button class="report-button" link type="primary" size="small" @click="pushTemplateToReportV4(row)">推至V4</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-drawer :open="open()" :closed="closeDialog()" v-model="dialog" destroy-on-close title="报表运行日期" direction="rtl" class="demo-drawer">
    <div class="demo-drawer__content">
      <div class="demo-drawer__footer">
        <el-date-picker v-model="selectReportTime" type="daterange" value-format="YYYY-MM-DD" unlink-panels range-separator="To" start-placeholder="开始时间" end-placeholder="结束时间" :shortcuts="shortcuts" />
        <el-divider />
        <el-button @click="selectDialogCancel">取消</el-button>
        <el-button type="primary" @click="selectDialogSubmit">
          运行
        </el-button>
      </div>
    </div>
  </el-drawer>

  <el-dialog v-model="v4DialogVisible" :title="v4TemplateData ? '修改V4数据清洗模板' : '同步至V4数据清洗模板'" width="50%">
    <el-form :model="v4Form" label-width="120px">
      <el-form-item label="V4报表标题">
        <el-input v-model="v4Form.title" placeholder="请输入报表标题" />
      </el-form-item>
      <el-form-item label="V4报表描述">
        <el-input v-model="v4Form.depict" placeholder="请输入报表描述" />
      </el-form-item>
      <el-form-item label="V4备注">
        <el-input v-model="v4Form.remark" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item label="V4预览图URL">
        <el-input v-model="v4Form.review_url" placeholder="请输入V4后台预览图URL" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="v4DialogVisible = false">取消同步</el-button>
      <el-button type="primary" @click="submitV4Template()">
        同步至V4数据清洗模板
      </el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="dialogVisible" :title="editDialogVisible ? '编辑模板' : '合并报表模板'" width="50%">
    <el-form :model="mergeForm" :rules="mergeFormRules" ref="mergeFormRef" label-width="120px">
      <el-form-item label="项目编码" prop="project_code">
        <el-input v-model="mergeForm.project_code" />
      </el-form-item>
      <el-form-item label="模板编码" prop="code">
        <el-input v-model="mergeForm.code" disabled />
      </el-form-item>
      <el-form-item label="模板类型编码" prop="template_code">
        <el-input v-model="mergeForm.template_code" disabled />
      </el-form-item>
      <el-form-item label="模板名称" prop="title" required>
        <el-input v-model="mergeForm.title" placeholder="请输入模板名称" />
      </el-form-item>
      <el-form-item label="模板类型" prop="type">
        <el-input v-model="mergeForm.type" disabled />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-input v-model="mergeForm.status" disabled />
      </el-form-item>

      <el-divider>模板规则</el-divider>

      <el-form-item label="钉钉WebHook" prop="rule.dingWebHookUrl">
        <el-input v-model="mergeForm.rule.dingWebHookUrl" placeholder="选填，不填写默认空字符串" />
      </el-form-item>

      <el-form-item label="合并模板映射" required>
        <div style="margin-bottom: 10px;">
          <el-button type="primary" @click="addSheet" size="small">增加Sheet</el-button>
        </div>
        <draggable v-model="sheetItems" item-key="id" @end="handleDragEnd" class="draggable-container">
          <template #item="{element}">
            <div style="margin-bottom: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <span style="width: 100px;">Sheet {{ element.id }}:</span>
                <el-input v-model="mergeForm.rule.mergeTemplateSheetNameMap[element.id]" placeholder="请输入Sheet名称" style="" />
                <el-select v-model="mergeForm.rule.mergeTemplateCodeMap[element.id]" filterable remote :remote-method="filterDr002Templates" :loading="loadingDr002" style="width: 300px" @change="(val) => handleTemplateChange(val, element.id)">
                  <el-option v-for="item in dr002Templates" :key="item.code" :label="item.title" :value="item.code" />
                </el-select>
                <el-button type="danger" link @click="removeSheet(element.id)" style="margin-left: 10px">
                  删除
                </el-button>
              </div>
            </div>
          </template>
        </draggable>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitMerge" :loading="mergeLoading">
        保存
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router'
const props = defineProps({
  height: Number
});
import { ref, onMounted, getCurrentInstance, computed } from 'vue';

const dialogVisible = computed({
  get: () => editDialogVisible.value || mergeDialogVisible.value,
  set: (val) => {
    if (editDialogVisible.value) {
      editDialogVisible.value = val;
    } else {
      mergeDialogVisible.value = val;
    }
  }
});
import draggable from 'vuedraggable';

// 按钮区域高度配置
const buttonHeight = 40; // 按钮高度
const buttonMargin = 10; // 按钮底部margin
const elMainPaddingTop = 20; // el-main padding
const elMainPaddingBottom = 20; // el-main padding
const otherHeight = buttonHeight + buttonMargin + elMainPaddingTop + elMainPaddingBottom;
import { generateHeaders } from '@/utils/sign';
import { ElMessage } from 'element-plus';
import api from '@/utils/http';
//获取全局
const { appContext } = getCurrentInstance();
// 定义响应式数据
const tableData = ref([]);
const loading = ref(false);
const uploading = ref(false);
const dialog = ref(false);
const selectReportTime = ref([]);
//存储弹窗当前row信息
const selectReportNowRow = ref();
const uploadInput = ref(null);
const selectedRows = ref([]);
const tableRef = ref(null);

function handleSelectionChange(selection) {
  selectedRows.value = selection;
}

const mergeDialogVisible = ref(false);
const editDialogVisible = ref(false);
const mergeLoading = ref(false);
const sheetItems = ref([]);
const dr002Templates = ref([]);
const loadingDr002 = ref(false);

function updateSheetItems() {
  sheetItems.value = Object.keys(mergeForm.value.rule.mergeTemplateCodeMap).map(key => ({
    id: key,
    sheetName: mergeForm.value.rule.mergeTemplateSheetNameMap[key],
    templateCode: mergeForm.value.rule.mergeTemplateCodeMap[key]
  }));
}

const mergeForm = ref({
  project_code: '',
  code: '',
  template_code: 'RMerge001',
  title: '',
  type: 'REPORT',
  status: 'finished',
  rule: {
    dingWebHookUrl: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
    mergeTemplateCodeMap: {},
    mergeTemplateSheetNameMap: {},
    templateCode: 'RMerge001',
    templateId: 0,
    templateType: 'REPORT',
    title: ''
  }
});

const mergeFormRules = {
  project_code: [{ required: true, message: '请输入项目编码', trigger: 'blur' }],
  title: [{ required: true, message: '请输入模板名称', trigger: 'blur' }]
};

function generateUUID() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  }).replace(/-/g, '');
}

async function loadDr002Templates() {
  try {
    loadingDr002.value = true;
    dr002Templates.value = tableData.value.filter(item => item.templateCode === 'DR002');
  } catch (error) {
    console.error('加载DR002模板失败:', error);
    ElMessage.error('加载DR002模板失败');
  } finally {
    loadingDr002.value = false;
  }
}

function filterDr002Templates(query) {
  if (!query) {
    dr002Templates.value = tableData.value.filter(item => item.templateCode === 'DR002');
    return;
  }
  dr002Templates.value = tableData.value.filter(item =>
    item.templateCode === 'DR002' &&
    item.title.toLowerCase().includes(query.toLowerCase())
  );
}

const currentRow = ref(null);
const v4DialogVisible = ref(false);
const v4Form = ref({
  title: '',
  depict: '',
  remark: '',
  review_url: ''
});
const v4TemplateData = ref(null);

async function pushTemplateToReportV4(row) {
  currentRow.value = row;
  try {
    // 检查是否已同步到V4
    v4TemplateData.value = await getTemplateHaveReportV4(row);

    if (v4TemplateData.value) {
      // 已同步 - 回显数据
      v4Form.value = {
        title: v4TemplateData.value.title || row.title,
        depict: v4TemplateData.value.depict || row.title,
        remark: v4TemplateData.value.remark || row.title,
        review_url: v4TemplateData.value.review_url || ''
      };
    } else {
      // 未同步 - 设置默认值
      v4Form.value = {
        title: row.title,
        depict: row.title,
        remark: row.title,
        review_url: ''
      };
    }

    v4DialogVisible.value = true;
  } catch (error) {
    console.error('推送模板到V4失败:', error);
    ElMessage.error('获取V4模板信息失败');
  }
}

async function submitV4Template() {
  const row = currentRow.value;
  try {
    let sql;
    if (v4TemplateData.value) {
      // 更新操作
      sql = `UPDATE tracking_cleaning.track_template 
             SET title = '${v4Form.value.title}',
                 depict = '${v4Form.value.depict}',
                 remark = '${v4Form.value.remark}',
                 review_url = '${v4Form.value.review_url}'
             WHERE template_type = '${row.id}' AND type = 2`;
    } else {
      // 插入操作
      sql = `INSERT INTO tracking_cleaning.track_template 
             (title, type, depict, remark, review_url, template_type) 
             VALUES 
             ('${v4Form.value.title}', 2, '${v4Form.value.depict}', 
              '${v4Form.value.remark}', '${v4Form.value.review_url}', '${row.id}')`;
    }

    const response = await restApi(sql);
    if (response.code == 200 && response.success) {
      ElMessage.success(v4TemplateData.value ? '修改成功' : '同步成功');
      v4DialogVisible.value = false;
    } else {
      throw new Error(response.errorMsg || '操作失败');
    }
  } catch (error) {
    console.error('操作失败:', error);
    ElMessage.error('操作失败，请联系管理员');
  }
}
async function getTemplateHaveReportV4(row) {
  if (!row || !row.id) {
    ElMessage.error('推送模板Id不存在，请刷新页面');
    return null;
  }
  try {
    const sql = `SELECT * FROM tracking_cleaning.track_template WHERE type = 2 AND template_type = '${row.id}'`;
    const response = await restApi(sql);
    if (response.code == 200 && response.success && response.data && response.data.length > 0) {
      return response.data[0];
    }
    return null;
  } catch (error) {
    console.error('获取模板V4信息失败:', error);
    throw error;
  }
}

async function editTemplate(row) {
  if (row.templateCode === 'DR002') {
    ElMessage.info('DR002编辑功能开发中，后续版本将考虑支持');
    return;
  }

  try {
    await loadDr002Templates();

    // 填充表单数据
    mergeForm.value = {
      id: row.id,
      project_code: row.projectCode,
      code: row.code,
      template_code: row.templateCode,
      title: row.title,
      type: row.type,
      status: row.status,
      rule: JSON.parse(row.rule)
    };

    // 更新sheetItems
    updateSheetItems();
    editDialogVisible.value = true;
  } catch (error) {
    console.error('打开编辑模板失败:', error);
    ElMessage.error(`打开编辑模板失败: ${error.message}`);
  }
}

async function mergeReport() {
  if (selectedRows.value.length < 2) return;

  try {
    //加载DR002模板
    await loadDr002Templates();
    // 设置默认值
    mergeForm.value.project_code = selectedRows.value[0].projectCode;
    mergeForm.value.code = generateUUID();
    mergeForm.value.title = `${selectedRows.value[0].title}-合并报表`;
    mergeForm.value.rule.templateId = Math.max(...tableData.value.map(t => t.id), 0) + 1;
    mergeForm.value.rule.title = mergeForm.value.title;

    // 初始化模板映射
    mergeForm.value.rule.mergeTemplateCodeMap = {};
    mergeForm.value.rule.mergeTemplateSheetNameMap = {};
    selectedRows.value.forEach((row, index) => {
      const sheetName = row.title.replace(/[\\/:*?"<>|]/g, '').replace(/模板引导/g, '');
      mergeForm.value.rule.mergeTemplateCodeMap[index + 1] = row.code;
      mergeForm.value.rule.mergeTemplateSheetNameMap[index + 1] = sheetName;
    });

    updateSheetItems();
    mergeDialogVisible.value = true;
  } catch (error) {
    console.error('合并报表失败:', error);
    if (error.message === 'Secret is required') {
      ElMessage.warning('操作已取消: 需要输入Secret才能继续');
    } else {
      ElMessage.error(`合并报表失败: ${error.message}`);
    }
  }
}

const mergeFormRef = ref(null);

function removeSheet(id) {
  delete mergeForm.value.rule.mergeTemplateCodeMap[id];
  delete mergeForm.value.rule.mergeTemplateSheetNameMap[id];
  updateSheetItems();
}

function handleTemplateChange(templateCode, sheetId) {
  const selectedTemplate = dr002Templates.value.find(t => t.code === templateCode);
  if (selectedTemplate) {
    mergeForm.value.rule.mergeTemplateSheetNameMap[sheetId] =
      selectedTemplate.title.replace(/[\\/:*?"<>|]/g, '').replace(/模板引导/g, '');
  }
}

function addSheet() {
  const newId = Object.keys(mergeForm.value.rule.mergeTemplateCodeMap).length > 0
    ? Math.max(...Object.keys(mergeForm.value.rule.mergeTemplateCodeMap).map(Number)) + 1
    : 1;

  mergeForm.value.rule.mergeTemplateCodeMap[newId] = '';
  mergeForm.value.rule.mergeTemplateSheetNameMap[newId] = '';
  updateSheetItems();
}

function handleDragEnd() {
  // 根据拖拽后的顺序重新构建数据
  const newCodeMap = {};
  const newNameMap = {};

  sheetItems.value.forEach((item, index) => {
    const newKey = index + 1;
    newCodeMap[newKey] = item.templateCode;
    newNameMap[newKey] = item.sheetName;
  });

  // 更新mergeForm中的数据
  mergeForm.value.rule.mergeTemplateCodeMap = newCodeMap;
  mergeForm.value.rule.mergeTemplateSheetNameMap = newNameMap;

  // 更新sheetItems的id以匹配新的顺序
  sheetItems.value = sheetItems.value.map((item, index) => ({
    ...item,
    id: index + 1
  }));
}

async function restApi(sql) {
  if (!sql) {
    return
  }
  const headers = await generateHeaders('weinxqlhhktop');
  const body = {
    method: 'api.wei.nxqlhhk.template',
    requestBody: { sql }
  };
  console.log('rest sql', sql);
  const response = await api.post(
    '/dw/admin/api/tracking/route/rest',
    body,
    headers
  );
  return response;
}

async function submitMerge() {
  try {
    // 验证基础表单
    await mergeFormRef.value.validate();

    // 手动校验Sheet名称和数量
    const sheetNames = mergeForm.value.rule.mergeTemplateSheetNameMap;
    const sheetCount = Object.keys(sheetNames).length;
    if (!sheetNames || sheetCount === 0) {
      throw new Error('请填写所有Sheet名称');
    }
    if (sheetCount < 2) {
      throw new Error('至少需要2个Sheet才能保存');
    }

    // 检查Sheet名称是否重复
    const nameSet = new Set();
    for (const key in sheetNames) {
      const name = sheetNames[key];
      if (!name || name.trim() === '') {
        throw new Error(`Sheet ${key} 名称不能为空`);
      }
      if (/[\\/:*?"“”<>|'‘’{}[\]]/.test(name)) {
        throw new Error(`Sheet ${key} 名称不能包含特殊字符(\\/:*?"“”<>|'‘’{}[])`);
      }
      if (nameSet.has(name)) {
        throw new Error(`Sheet名称"${name}"重复，请确保每个Sheet名称唯一`);
      }
      nameSet.add(name);
    }

    mergeLoading.value = true;

    let sql;
    if (editDialogVisible.value) {
      // 编辑模式 - 生成UPDATE语句
      sql = `UPDATE automatic_report.\`t_template\` SET 
        \`project_code\`='${mergeForm.value.project_code}',
        \`title\`='${mergeForm.value.title}',
        \`rule\`='${JSON.stringify(mergeForm.value.rule)}'
        WHERE \`id\`=${mergeForm.value.id}`;
    } else {
      // 合并模式 - 生成INSERT语句
      sql = `INSERT INTO automatic_report.\`t_template\` (
        \`id\`,\`project_code\`,\`code\`,\`template_code\`,\`title\`,\`type\`,\`rule\`,\`status\`) 
        VALUES 
        (${mergeForm.value.rule.templateId},'${mergeForm.value.project_code}','${mergeForm.value.code}','${mergeForm.value.template_code}',
        '${mergeForm.value.title}','${mergeForm.value.type}','${JSON.stringify(mergeForm.value.rule)}','${mergeForm.value.status}')`;
    }

    const body = {
      method: 'api.wei.nxqlhhk.template',
      requestBody: { sql }
    };
    const response = await restApi(sql);

    if (response.code == 200 && response.success) {
      ElMessage.success(editDialogVisible.value ? '编辑完成' : '合并完成');
      if (editDialogVisible.value) {
        editDialogVisible.value = false;
      } else {
        mergeDialogVisible.value = false;
      }
      await getTemplateReportList();
    } else {
      throw new Error(response.errorMsg || '合并报表失败');
    }
  } catch (error) {
    console.error('合并报表失败:', error);

    if (error && typeof error === 'object' && !error.message) {
      // 处理字段级错误提示
      var messages = [];

      Object.keys(error).forEach(function (field) {
        var errors = error[field];
        if (Array.isArray(errors)) {
          errors.forEach(function (errObj) {
            var msg = errObj && errObj.message ? errObj.message : JSON.stringify(errObj);
            messages.push(field + ': ' + msg);
          });
        } else {
          messages.push(field + ': ' + JSON.stringify(errors));
        }
      });

      var finalMsg = messages.join('；'); // 用中文分号分隔
      ElMessage.error('合并报表失败: ' + finalMsg);
    } else if (error && error.message) {
      ElMessage.error('合并报表失败: ' + error.message);
    } else {
      ElMessage.error('合并报表失败: 请检查表单填写是否正确');
    }
  } finally {
    mergeLoading.value = false;
  }
}
function copyText(text, alertMsg) {
  if (!text) return;

  // 现代浏览器API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(() => {
        ElMessage.success(alertMsg);
      })
      .catch(() => {
        // 降级方案
        fallbackCopyText(text);
      });
  } else {
    // 旧浏览器降级方案
    fallbackCopyText(text);
  }

}

function copyUrl(url) {
  copyText(url, 'URL已复制到剪贴板，双击快速下载');
}

function fallbackCopyText(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';  // 防止页面滚动
  document.body.appendChild(textarea);
  textarea.select();

  try {
    const successful = document.execCommand('copy');
    if (successful) {
      ElMessage.success('URL已复制到剪贴板，双击快速下载');
    } else {
      ElMessage.error('复制失败，请手动复制');
    }
  } catch (err) {
    ElMessage.error('复制失败，请手动复制');
  } finally {
    document.body.removeChild(textarea);
  }
}

async function downloadUrl(url, fileName = '') {
  if (!url) return;

  try {
    // 获取文件内容
    const response = await fetch(url);
    const blob = await response.blob();

    // 创建下载链接
    const a = document.createElement('a');
    const downloadUrl = window.URL.createObjectURL(blob);

    // 设置文件名
    let finalName = fileName;
    if (fileName) {
      // 确保文件名合法
      finalName = fileName.replace(/[\\/:*?"<>|]/g, '');

      // 从URL中获取文件扩展名
      const urlParts = url.split('/');
      const originalFileName = urlParts[urlParts.length - 1];
      const extensionMatch = originalFileName.match(/\.([a-zA-Z0-9]+)$/);
      const extension = extensionMatch ? extensionMatch[0] : '.xlsx';

      // 添加扩展名
      if (!finalName.endsWith(extension)) {
        finalName += extension;
      }
    } else {
      // 从URL中提取原文件名
      const urlParts = url.split('/');
      finalName = urlParts[urlParts.length - 1];
    }

    a.href = downloadUrl;
    a.download = finalName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    // 清理
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error('下载失败:', error);
    ElMessage.error('文件下载失败');
  }
}
const shortcuts = [
  {
    text: '最近一天',
    value: () => {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 0);
      return [start, end];
    },
  },
  {
    text: '最近三天',
    value: () => {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 2);
      return [start, end];
    },
  },
  {
    text: '最近一周',
    value: () => {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
      return [start, end];
    },
  },
  {
    text: '最近一月',
    value: () => {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 29);
      return [start, end];
    },
  },
  {
    text: '最近3个月',
    value: () => {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 89);
      return [start, end];
    },
  },
];

onMounted(() => {
  console.log('onMouted.....');
  getTemplateReportList();
  // api.get();
});
function open() {
  console.log('open....');
}

function msg(text, type) {
  if (type) {
    ElMessage({
      message: text,
      type: type,
    });
  } else {
    ElMessage({
      message: text,
      type: 'success',
    });
  }
}

async function handleClick(row) {
  // console.log('操作行：', row)
  //打开弹窗
  dialog.value = true;
  //开始运行
  selectReportNowRow.value = row;
  console.log('selectReportNowRow', selectReportNowRow);
}
async function runReportApi(row, startTime, endTime) {
  console.log('开始运行报表：', row);
  console.log('开始运行报表：', row.id, startTime, endTime);
  let url = '/v3/admin/v1/template/start/' + row.id;
  let query = {
    startDay: startTime,
    endDay: endTime,
  };
  let result = await api.get(url, query);
  if (result && result.success) {
    msg(result.data, 'success');
    result.data.data;
  } else {
    msg(result.errorMsg, 'warning');
  }
  getTemplateReportList();
}
function selectDialogCancel() {
  dialog.value = false;
  getTemplateReportList();
}

async function selectDialogSubmit() {
  //现在选择的运行时间
  if (!selectReportTime.value || !selectReportTime.value[0] || !selectReportTime.value[0]) {
    // 日期未选择
    msg('未选择报表日期，请重新选择', 'warning');
    return;
  }
  console.log('selectReportTime', selectReportTime.value, selectReportTime.value[0], selectReportTime.value[1]);
  await runReportApi(selectReportNowRow.value, selectReportTime.value[0], selectReportTime.value[1]);
  dialog.value = false;
}
function closeDialog() {
  //取消选择的日期和row
  console.log(`关闭或者取消弹窗`);

  selectReportTime.value = ['', ''];
}

async function getTemplateReportList() {
  loading.value = true;
  let url = '/v3/admin/v1/template/list?page=1&pageSize=9999';
  let query = {
    //  "title": '阿伟'
  };
  let result;
  try {
    result = await api.post(url, query);
    if (result && result.success) {
      tableData.value = result.data.data;
    }
  } catch (e) {
    console.log(e);
  }
  console.log(result);
  loading.value = false;
}

function uploadTemplate() {
  uploadInput.value.dataset.id = '';
  uploadInput.value.click();
}

function updateTemplate(id) {
  uploadInput.value.dataset.id = id;
  uploadInput.value.click();
}

async function handleUploadChange(event) {
  const file = event.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  const id = uploadInput.value.dataset.id;
  const url = id ? `/v3/admin/v1/template/update/${id}` : '/v3/admin/v1/template/upload';

  uploading.value = true;
  try {
    const response = await api.upload(url, formData, null);
    if (response && response.success) {
      msg(response.data, 'success');
      getTemplateReportList();
    } else {
      msg(response.errorMsg, 'warning');
    }
  } catch (error) {
    msg('模板上传失败！', 'error');
  } finally {
    uploading.value = false;
    uploadInput.value.value = ''; // 清空文件输入框
  }
}

async function abortTemplate(id) {
  const url = `/v3/admin/v1/template/abort/${id}`;
  try {
    const response = await api.get(url);
    if (response && response.success) {
      msg('任务已终止！');
      getTemplateReportList();
    } else {
      msg(response.errorMsg, 'warning');
    }
  } catch (error) {
    msg('任务终止失败！', 'error');
  }
}
// 跳转到模板翻译页面
const router = useRouter();
const goToTranslateTemplate = () => {
  // 跳转方式一：根据 path
  router.push('/tools-translate-template')

  // 跳转方式二：根据 name
  // router.push({ name: 'tools-translate-template' })
}
</script>

<style scoped>
.button-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.report-button {
  margin-left: 2px !important;
  margin-right: 2px !important;
  min-width: auto !important; /*防止按钮宽度被撑开*/
}

.el-table__body-wrapper {
  overflow-x: auto;
}

.el-table {
  box-sizing: border-box;
  overflow: hidden;
  table-layout: fixed;
}
.el-table :deep(.el-table__cell) {
  padding: 8px 0;
}
.el-table :deep(.el-checkbox) {
  vertical-align: middle;
}
.el-table :deep(.el-table__header-wrapper .el-table__cell) {
  padding: 8px 0;
}
.el-table :deep(.el-table__body-wrapper .el-table__cell) {
  padding: 8px 0;
}

.draggable-container {
  width: 100%;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.draggable-container > div {
  cursor: move;
  transition: all 0.3s;
}

.draggable-container > div:hover {
  background-color: #f0f2f5;
}
</style>
